import React from 'react'
import './VcMsg.css'

import DirectorOric from "../assets/DirectorOric.jpeg"
const VcMsg = () => {
  return (
    <>
  
    <div className="messages-container">
      {/* CEO Message */}
        <div className="message-section">
        
        <img src={DirectorOric} alt="CEO" className="ceo-pic" />
        
        <div className="message-content">
          <h2>Manager ORIC Message</h2>

          <p>
          Office of Research, Innovation and Commercialization (ORIC-SBBWU) is striving to cultivate a culture of academic inquiry and practical application to attain long term sustainability through research. We are serving as a catalyst for advancing knowledge and addressing societal challenges through rigorous research endeavours. Our primary objective is to foster an environment where groundbreaking research is not only encouraged but also translated into tangible solutions that benefit both local communities and the broader society. To ensure research outcomes have practical implications, collaboration between academia, industry and government sectors has become imperative for contributing to national development goals and for acquiring the relevant SDGs. ORIC-SBBWU is striving hard to bridge the gap between academia and industry by establishing joint research projects with industry partners, facilitate internships and industrial placements for students and by organizing industry-focused workshops and seminars. Rigorous efforts are also put in to enhance the research capabilities of faculty members, researchers, and students by providing them with resources, funding opportunities, and strategic guidance. ORIC-SBBWU’s is committed to shape a future where research drives positive change and sustainable development through fostering a culture of innovation and entrepreneurship  and by promoting  technology transfer and commercialization of research     
          </p>
        </div>
      </div>

      {/* Director Message */}
 
    </div>
    </>
  );
};





export default VcMsg